import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  // Log the raw error + React component stack so the DevTools console
  // shows exactly where the crash came from. Source maps (enabled in
  // vite.config.js) map the minified frame back to real file:line so
  // "Cannot access 'E' before initialization" tells us which symbol
  // and which file.
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error)
    console.error('[ErrorBoundary] component stack:', info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="text-center">
            <h1 className="font-display text-3xl text-incorrect mb-2">Something went wrong</h1>
            <p className="text-text-secondary mb-4">{this.state.error?.message || 'An unexpected error occurred'}</p>
            <button
              onClick={() => window.location.reload()}
              className="bg-accent hover:bg-accent-hover text-white px-6 py-2 rounded-lg transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
